<div [formGroup]="headFormGroup" class="p-3">
	<div class="row g-4">

		<div class="col-12 col-lg-4">
			<app-company-select formControlName="company_id" [label]="'form.field.company' | translate"
				[required]="true" [submitted]="submitted" [debug]="debug" [disabled]="disableCompanySelect"
				(companyChange)="forwardCompanyChange($event)">
			</app-company-select>
		</div>

		<div class="col-12 col-lg-4">
			<app-customer-select formControlName="customer_id" [label]="'form.field.customer' | translate"
				[required]="true" [submitted]="submitted" [debug]="debug"
				[companyId]="currentCompanyId"
				(customerChange)="forwardCustomerChange($event)">
			</app-customer-select>
		</div>

		<div class="col-12 col-lg-4">
			<app-date-select formControlName="invoice_date" [label]="'form.field.invoiceDate' | translate"
				[required]="true" [defaultToToday]="true" [submitted]="submitted" [debug]="debug"
				(dateChange)="forwardDateChange($event)">
			</app-date-select>
		</div>

		<div class="col-12">
			<div [class]="showAdditionalInfo ? 'row g-4' : 'd-none'">

				<div class="col-12 col-lg-4" *ngIf="isVatTypeRelevant(documentType)">
					<app-vat-select formControlName="vat_list_id" [label]="'form.field.vatType' | translate"
						[required]="true" [submitted]="submitted" [debug]="debug"
						(vatTypeChange)="forwardVatTypeChange($event)">
					</app-vat-select>
				</div>

				<div class="col-12 col-lg-4">
					<app-language-select formControlName="document_language"
						[label]="'form.field.documentLanguage' | translate" [required]="true"
						[availableLanguages]="availableLanguages" [submitted]="submitted" [debug]="debug"
						(languageChange)="forwardLanguageChange($event)">
					</app-language-select>
				</div>

				<div class="col-12 col-lg-4">
					<app-currency-select formControlName="currency" [label]="'form.field.currency' | translate"
						[required]="true" [submitted]="submitted" [debug]="debug"
						(currencyChange)="forwardCurrencyChange($event)">
					</app-currency-select>
				</div>
			</div>

			<button pButton type="button" class="p-button-outlined p-button-secondary p-button-sm"
				(click)="showAdditionalInfo =! showAdditionalInfo" [ngClass]="showAdditionalInfo ? 'mt-3' : ''">
				{{ !showAdditionalInfo ? ('modal.common.showAdditionalInfo' | translate) :
				('modal.common.hideAdditionalInfo' | translate) }}
			</button>
		</div>
	</div>
</div>

<p-dialog header="{{ 'documentSequenceModal.promptTitle' | translate }}" [(visible)]="createSequenceDialogVisible"
	[modal]="true" [style]="{ width: '300px' }" [draggable]="false" [resizable]="false">

	<div class="p-fluid">
		<p>{{ 'documentSequenceModal.promptMessage' | translate }}</p>
		<div class="field mt-3">
			<label for="startNumber">{{ 'documentSequenceModal.promptStartNumberLabel' | translate }}</label>
			<p-inputNumber id="startNumber" [(ngModel)]="sequenceStartNumber" [min]="1" [showButtons]="true"
				buttonLayout="horizontal" spinnerMode="horizontal" incrementButtonIcon="pi pi-plus"
				decrementButtonIcon="pi pi-minus" [useGrouping]="false" [minFractionDigits]="0" [maxFractionDigits]="0">
			</p-inputNumber>
		</div>
	</div>

	<ng-template pTemplate="footer">
		<p-button label="{{ 'documentSequenceModal.promptAcceptLabel' | translate }}" icon="pi pi-check"
			styleClass="p-button-success" (click)="confirmCreateSequence()"
			[disabled]="sequenceStartNumber === null || sequenceStartNumber <= 0"></p-button>
		<p-button label="{{ 'modal.common.cancel' | translate }}" icon="pi pi-times" styleClass="p-button-text"
			(click)="cancelCreateSequence()"></p-button>
	</ng-template>
</p-dialog>

<p-toast></p-toast>